import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Nav } from './Nav';
import { Footer } from './Footer';
type LayoutProps = {
  children: React.ReactNode;
};
export function Layout({
  children
}: LayoutProps) {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'auto'
    });
  }, [pathname]);
  return <div className="flex min-h-screen w-full flex-col bg-paper font-sans text-ink" data-id="element-58" data-mp="uwgqqnyu73p9">
      <a href="#main-content" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-ink focus:px-5 focus:py-3 focus:text-[14px] focus:font-medium focus:text-paper" data-id="element-59" data-mp="76mdi5alvd4h">
        Skip to main content
      </a>
      <Nav data-id="element-60" data-mp="c6ih43fe52ji" />
      <main id="main-content" className="flex-1 pt-[68px]" data-id="element-61" data-mp="c5qmovxj5aut">
        {children}
      </main>
      <Footer data-id="element-62" data-mp="3klsc6rkv57hs" />
    </div>;
}